/**
 * Cart Direct Navigation - Disable All Modal/Popup Behavior
 *
 * This script completely disables:
 * - Cart drawer popups
 * - Quick view modals
 * - Upsell/cross-sell popups
 * - Body scroll locking
 * - Content shifting
 *
 * Result: Clean, direct navigation to cart page
 */

(function() {
  'use strict';

  console.log('[Cart Direct Navigation] Initializing...');

  /**
   * Remove body classes that cause layout shifts
   */
  function removeBodyShiftClasses() {
    const shiftyClasses = [
      'modal-open',
      'drawer-open',
      'overflow-hidden',
      'js-drawer-open',
      'js-modal-open',
      'cart-drawer-open',
      'quick-view-open'
    ];

    shiftyClasses.forEach(function(className) {
      if (document.body.classList.contains(className)) {
        document.body.classList.remove(className);
        console.log('[Cart Direct Navigation] Removed class:', className);
      }
    });

    // Force body to be scrollable
    if (document.body.style.overflow === 'hidden') {
      document.body.style.overflow = '';
      console.log('[Cart Direct Navigation] Restored body overflow');
    }

    // Remove padding-right added to compensate for scrollbar
    if (document.body.style.paddingRight) {
      document.body.style.paddingRight = '';
      console.log('[Cart Direct Navigation] Removed body padding');
    }
  }

  /**
   * Block all modal/drawer opening attempts
   */
  function blockModalOpeners() {
    // Prevent clicks on elements that try to open modals/drawers
    const blockSelectors = [
      '.js-drawer-open-right',
      '.js-drawer-open-left',
      '.js-modal-link',
      '.js-product-quick-view',
      '[data-upsell-id]',
      '[data-cross-sell-id]',
      '[data-modal-id]'
    ];

    blockSelectors.forEach(function(selector) {
      const elements = document.querySelectorAll(selector);
      elements.forEach(function(element) {
        element.addEventListener('click', function(e) {
          // If this is NOT a cart icon (which should navigate), prevent modal behavior
          const isCartIcon = element.closest('.js-cart-link') ||
                           element.classList.contains('js-cart-link') ||
                           element.getAttribute('href') === '/cart';

          if (!isCartIcon) {
            console.log('[Cart Direct Navigation] Blocked modal opener:', selector);
            // Don't prevent default - let Add to Cart work!
            // Just remove any classes that were added
            setTimeout(removeBodyShiftClasses, 10);
          }
        });
      });
    });
  }

  /**
   * Intercept Add to Cart buttons to prevent popups
   */
  function interceptAddToCart() {
    const addToCartButtons = document.querySelectorAll('.js-product-add-to-cart-button');

    addToCartButtons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        console.log('[Cart Direct Navigation] Add to Cart clicked');

        // Remove any upsell/cross-sell triggers
        button.removeAttribute('data-upsell-id');
        button.removeAttribute('data-cross-sell-id');

        // After AJAX completes, ensure no body shifts happened
        setTimeout(function() {
          removeBodyShiftClasses();
          console.log('[Cart Direct Navigation] Cleaned up after Add to Cart');
        }, 100);

        // Let the normal Add to Cart AJAX happen
        // Then redirect to cart page after success
        setTimeout(function() {
          // Check if item was added (cart count changed or no error message)
          const errorMessage = document.querySelector('.product-control__error');
          if (!errorMessage || !errorMessage.textContent.trim()) {
            console.log('[Cart Direct Navigation] Redirecting to cart page...');
            window.location.href = '/cart';
          }
        }, 800);
      });
    });
  }

  /**
   * Continuous monitoring to prevent body shifts
   */
  function startBodyMonitoring() {
    // Check every 100ms for unwanted body classes/styles
    setInterval(removeBodyShiftClasses, 100);

    // Also use MutationObserver for immediate detection
    if (window.MutationObserver) {
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' &&
              (mutation.attributeName === 'class' || mutation.attributeName === 'style')) {
            removeBodyShiftClasses();
          }
        });
      });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class', 'style']
      });

      console.log('[Cart Direct Navigation] Body monitoring active');
    }
  }

  /**
   * Initialize when DOM is ready
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        console.log('[Cart Direct Navigation] DOM ready, activating...');
        removeBodyShiftClasses();
        blockModalOpeners();
        interceptAddToCart();
        startBodyMonitoring();
      });
    } else {
      console.log('[Cart Direct Navigation] Already loaded, activating now...');
      removeBodyShiftClasses();
      blockModalOpeners();
      interceptAddToCart();
      startBodyMonitoring();
    }
  }

  // Start immediately
  init();

})();
